// extracted by mini-css-extract-plugin
export var callCard = "_og-0";
export var callMessageButton = "_og-1";
export var helpIcon = "_og-3";
export var helpIconContainer = "_og-4";
export var verticalDivider = "_og-2";